import ContactDetailsDesktop from "@components/requestQuote/ContactDetailsDesktop";
import DesktopModal from "@components/requestQuote/DesktopModal";
import SuccessScreenDesktop from "@components/requestQuote/SuccessScreenDesktop";
import { RAQ_FORM_TYPES } from "@components/utils/constants";
import { ITopNavigationResponse } from "@customTypes/commonResponses";
import { steps } from "@customTypes/index";
import {
    IAccommodationResponse,
    IActivityResponse,
    ILocationResponse,
} from "@customTypes/modelResponses";
import useAppContext from "@hooks/useAppContext";
import { IUseRequestQuoteReturn } from "@hooks/useRequestQuote";
import { ITripPreferencesProps } from "@modules/requestAQuote/RaQFullForm";
import { RaQFormType } from "pages/things-to-do/[...slug]";
import ContactDetails from "./ContactDetails";
import Modal from "./Modal";
import Specifics from "./Specifics";
import SuccessScreen from "./SuccessScreen";

interface IRequestQuoteProps
  extends Pick<
    IUseRequestQuoteReturn,
    | "onRequestOpen"
    | "onStepOneClick"
    | "onStepTwoClick"
    | "onStepThreeClick"
    | "onRequestSubmit"
  > {
  step: boolean | string;
  topNavigation?: ITopNavigationResponse;
  packageData?:
    | ILocationResponse
    | IAccommodationResponse
    | IActivityResponse;
  raqFormType: RaQFormType;
  tripPreferencesProps: ITripPreferencesProps;
}

const RequestQuote = ({
  step,
  onRequestOpen,
  onStepOneClick,
  onStepTwoClick,
  onStepThreeClick,
  onRequestSubmit,
  topNavigation,
  packageData,
  raqFormType,
  tripPreferencesProps,
}: IRequestQuoteProps): JSX.Element => {
  const { stepOne, stepTwo, stepThree, success } = steps;
  const { isMobile } = useAppContext();

  const handleRequestQuoteModals = (
    type: string | boolean
  ): JSX.Element | undefined => {
    switch (type) {
      case stepOne:
        if (isMobile)
          return (
            <Modal
              onRequestOpen={onRequestOpen}
              onClick={onStepOneClick}
              packageData={packageData}
              raqFormType={raqFormType}
              phone={{
                phoneAction: `tel:${topNavigation?.Phone_Action}`,
                phoneNumber: topNavigation?.Phone_Visible,
              }}
              tripPreferencesProps={tripPreferencesProps}
            />
          );
        else if (raqFormType === RAQ_FORM_TYPES.FORM_A) {
          return (
            <DesktopModal
              onRequestOpen={onRequestOpen}
              onClick={onStepOneClick}
              topNavigation={topNavigation}
            />
          );
        } else {
          return <></>;
        }
      case stepTwo:
        if (isMobile)
          return (
            <Specifics
              onRequestOpen={onRequestOpen}
              onBackClick={onStepOneClick}
              onClick={onStepTwoClick}
            />
          );
        else
          return (
            <ContactDetailsDesktop
              onRequestOpen={onRequestOpen as () => void}
              onClick={onStepTwoClick}
              onRequestSubmit={onRequestSubmit}
              onBackClick={onRequestOpen}
              topNavigation={topNavigation}
            />
          );
      case stepThree:
        if (isMobile)
          return (
            <ContactDetails
              onRequestOpen={onRequestOpen as () => void}
              onBackClick={onStepThreeClick}
              onClick={onStepTwoClick}
              onRequestSubmit={onRequestSubmit}
            />
          );
        else return <SuccessScreenDesktop onRequestOpen={onRequestOpen} />;
      case success:
        return <SuccessScreen onRequestOpen={onRequestOpen} />;
    }
  };

  return <>{handleRequestQuoteModals(step)}</>;
};

export default RequestQuote;
